import { types } from 'mobx-state-tree'

const FeatureImageModel = types
  .model('FeatureImageModel')
  .props({
    url: types.optional(types.string, ''),
    description: types.maybeNull(types.string),
  })
  .actions((self: any) => ({
    mapURL: (value: any) => {
      self.url = value.url
      self.description = value.description
    },
    mapCaption: (value: any) => {
      self.caption = value
    },
  }))

const PhotoListModel = types
  .model('PhotoListModel')
  .props({
    url: types.optional(types.string, ''),
    description: types.maybeNull(types.string),
  })
  .actions((self: any) => ({
    mapURL: (value: any) => {
      self.url = value.url
      self.description = value.description
    },
  }))

export const GalleryModel = types
  .model('GalleryModel')
  .props({
    listing_setup_step: types.optional(types.number, 3),
    feature_images: types.optional(FeatureImageModel, {} as any),
    gallery_list: types.optional(types.array(PhotoListModel), []),
    video_link_list: types.optional(types.array(types.string), []),
    status: types.optional(
      types.enumeration('status', ['changed', 'keep']),
      'keep'
    ),
  })
  .actions((self: any) => {
    const setStatus = (value: 'changed' | 'keep') => {
      self.status = value
    }
    const mapFeaturePayload = (value: any) => {
      switch (value.add) {
        case 'featureImage':
          self.feature_images.mapURL(value.value)
          break
        case 'caption':
          self.feature_images.mapCaption(value.data)
          break
        default:
          null
          break
      }
    }

    const mapPhotosPayload = (value: any) => {
      if (value.add === 'photos') {
        self.gallery_list = value.value.gallery_list
      }
    }

    const mapVideoListPayload = (value: string[]) => {
      self.video_link_list = value
    }

    const getPayload = () => {
      return { ...self }
    }

    return {
      mapFeaturePayload,
      mapPhotosPayload,
      getPayload,
      mapVideoListPayload,
      setStatus,
    }
  })
